import { useSnackbars } from '@customerio/pluma-components/react';
import { WORKSPACE_MISMATCH_SNACKBAR_KEY } from '@/features/account-switcher/constants';
import { useMountEffect } from '@/hooks/state/use-mount-effect';

function getWorkspaceMismatchSnackbar(): boolean {
  try {
    const raw = sessionStorage.getItem(WORKSPACE_MISMATCH_SNACKBAR_KEY);
    return raw != null;
  } finally {
    sessionStorage.removeItem(WORKSPACE_MISMATCH_SNACKBAR_KEY);
  }
}

/**
 * After a workspace mismatch redirect (no session has access to the workspace
 * in the URL), checks sessionStorage for a pending snackbar marker and displays
 * a "no permission" message.
 */
export function useWorkspaceMismatchSnackbar(): void {
  const snackbars = useSnackbars();

  useMountEffect(() => {
    const shouldShow = getWorkspaceMismatchSnackbar();
    if (!shouldShow) {
      return;
    }

    snackbars.create({
      message: "You don't have permission to view that page",
      variant: 'error',
    });
  });
}
